import { Plus } from 'components/Icons';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { Spinner } from 'components';
export const ShowMoreButton = (props) => {
  const { className, style, onClick, text, icon, loading } = props;

  return (
    <div
      className={classNames(styles.showMoreIconButton, className)}
      style={style}
      onClick={onClick}
    >
      {loading ? (
        <Spinner loaderClassName={styles.buttonLoader} />
      ) : (
        <>
          {icon || <Plus color="#515151" className={styles.addIcon} />}
          <div className={styles.text}>{text}</div>
        </>
      )}
    </div>
  );
};
